/**
 * ISO-string → Unix-seconds conversion used by chart prefetch + chart render.
 * Returns `undefined` for null/undefined/unparseable input so callers can fall
 * back to a Date.now() default.
 */
export function isoToUnix(iso: string | null | undefined): number | undefined {
  if (iso === null || iso === undefined) return undefined;
  const ms = new Date(iso).getTime();
  return Number.isNaN(ms) ? undefined : Math.floor(ms / 1000);
}
